
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicMenusApi extends BaseModulePublicApi {
  basePath = 'menus';
};
